import api from "@/lib/axios";

export const formsService = {
  // Get all forms
  getAllForms: async () => {
    try {
      const response = await api.get("/forms");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch forms: " + error.message);
    }
  },

  // Create a new form
  createForm: async (formData) => {
    try {
      const response = await api.post("/forms", formData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to create form: " + error.message);
    }
  },

  // Get a specific form by ID
  getFormById: async (formId) => {
    try {

      const response = await api.get(`/forms/${formId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch form: " + error.message);
    }
  },

  // Update a form
  updateForm: async (formId, formData) => {
    try {
      const response = await api.post(`/form/update-with-fields/${formId}`, {
        ...formData,
        // _method: "PUT"
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to update form: " + error.message);
    }
  },

  
  // Update form fields
  updateFormFields: async (fieldData) => {
    try {
      const response = await api.post("/forms/field-update", fieldData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update form fields: " + error.message);
    }
  },

  // Get personal info form
  getPersonalInfoForm: async () => {
    try {
      const response = await api.get("/form/personal-info");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch personal info form: " + error.message);
    }
  },

  // Get job forms
  getJobForms: async () => {
    try {
      const response = await api.get("/form/job-form");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch job forms: " + error.message);
    }
  },

  // Update form with fields
  updateFormWithFields: async (formId) => {
    try {
      const response = await api.get(`/form/update-with-fields/${formId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update form with fields: " + error.message);
    }
  },

  // Delete a form
  deleteForm: async (formId) => {
    try {
      const response = await api.delete(`/forms/${formId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete form: " + error.message);
    }
  },

  // Duplicate a form
  duplicateForm: async (formId) => {
    try {
      const response = await api.get(`/form/${formId}/duplicate`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to duplicate form: " + error.message);
    }
  }
};

  

